import { render, staticRenderFns } from "./SetupCompany.vue?vue&type=template&id=4a5f3b01&scoped=true&"
import script from "./SetupCompany.vue?vue&type=script&lang=js&"
export * from "./SetupCompany.vue?vue&type=script&lang=js&"
import style0 from "./SetupCompany.vue?vue&type=style&index=0&id=4a5f3b01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f3b01",
  null
  
)

export default component.exports